import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={10 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 10 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.84441 9.61588C8.69939 10.3014 8.51106 10.7189 8.27266 11.1761C8.05692 11.5902 7.85587 11.9285 7.82329 12.4157C7.62701 15.3321 6.90707 20.4307 6.78827 24.5672C6.67345 28.5742 5.82198 29.3615 5.39923 29.3233C4.93079 29.2808 4.88828 27.5309 4.39958 24.861C3.87512 21.9943 3.64983 20.415 3.34985 18.3909C3.01611 16.1371 3.00379 14.9275 2.78924 13.4466C2.66924 12.6192 2.58461 12.0746 2.47495 11.6581C2.34225 11.1546 2.26477 10.9176 1.99936 10.385C1.48721 9.35744 1.06447 4.86745 1.83686 3.52031C2.3053 2.70343 2.59852 2.35422 3.27516 2.1254C3.70148 1.98161 4.63916 1.341 5.35474 1.32524C6.0278 1.30995 6.57809 1.56505 7.54 1.89945C8.19558 2.12731 8.56589 2.28018 9.02757 2.99197C9.78685 4.16331 9.25961 7.65488 8.84441 9.6154V9.61588Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
